export default __webpack_public_path__ + "static/media/3.72ae7027.jpg";